export const GET_CATEGORIES = 'providers/menuMaker/Categories/GET_CATEGORIES';
export const GET_PAGINATION_CATEGORY = 'providers/menuMaker/Categories/GET_PAGINATION_CATEGORY';
export const CREATE_CATEGORY = 'providers/menuMaker/Categories/CREATE_CATEGORY';
export const DELETE_CATEGORY = 'providers/menuMaker/Categories/DELETE_CATEGORY';
export const DUPLICATE_CATEGORY = 'providers/menuMaker/Categories/DUPLICATE_CATEGORY';
